import {Injectable, NgZone, OnDestroy} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "./auth.service";
import {environment} from "../../../environments/environment";
import {LoginLockDialogComponent} from "../components/login-lock-dialog/login-lock-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class MercureService implements OnDestroy {
  private eventSource: EventSource | null = null;
  private asf24BaseUrl = environment.asf24;
  private readonly hubUrl = this.asf24BaseUrl + '/rest/mercure/';
  private dialogRef: MatDialogRef<LoginLockDialogComponent> | null = null;


  constructor(
    private zone: NgZone,
    private dialog: MatDialog,
    private authService: AuthService,
  private snack: MatSnackBar,
    // private lockDialogComponent: LoginLockDialogComponent,
) { }


  /**
   * Tworzy strumień danych dla konkretnego tematu (topic)
   */
  connect(topic: string): Observable<any> {
    this.disconnect();

    const url = new URL(this.hubUrl);
    url.searchParams.append('topic', topic);

    const messageSubject = new Subject<any>();

    this.eventSource = new EventSource(url.toString());


    this.eventSource.onmessage = (event: MessageEvent) => {
      this.zone.run(() => {
        try {
          const data = JSON.parse(event.data);
          messageSubject.next(data);

          this.authService.loadProfile();

          if (data && data.startAt) {
            // this.lockDialogComponent.ngOnDestroy();
            if (this.dialogRef) {
              this.dialogRef.close();
            }
            this.dialog.open(LoginLockDialogComponent, {
              width: '500px',
              data: { startAt: data.startAt, endAt: data.endAt }
            });
          }
        } catch (error) {
          console.error('Błąd parsowania danych z Mercure:', error);
        }
      });
    };

    this.eventSource.onerror = (error) => {
      console.error('Błąd połączenia z hubem Mercure:', error);
    };

    return messageSubject.asObservable();
  }

  /**
   * Zamyka aktywne połączenie SSE
   */
  disconnect(): void {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
      // console.log('Połączenie z Mercure zostało zamknięte.');
    }
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
